import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/update-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "putData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "CANCEL_TRANSPORT_" }
);

export interface CancelTransportState extends IState {}

const INITIAL_STATE: CancelTransportState = {
  loading: false,
  error: null,
};

const request = (state: CancelTransportState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: CancelTransportState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: CancelTransportState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const cancelTransport = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const CancelTransportTypes = Types;
export const CancelTransportActions = Creators;
